import { forwardRef, useRef } from "react";
import { useIntersectionObserver } from "../../hooks";
import Clickable from "../Clickable";
import { styles } from "./styles";
import { ChatCueProps } from "./types";

/**
 * `Chat.Cue` component represents an individual message cue (suggested message) in the chat interface.
 */
const ChatCue = forwardRef<HTMLDivElement, ChatCueProps>(
  ({ children, onClick, disabled }, ref) => {
    const cueRef = useRef<HTMLDivElement | null>(null);

    const setIntersectionRef = useIntersectionObserver({
      threshold: 0.99,
      onIntersection: ([entry]) => {
        cueRef.current?.classList.toggle("not-visible", !entry.isIntersecting);
      }
    });
    return (
      <div
        className="kit-ChatCue"
        ref={current => {
          cueRef.current = current;
          if (typeof ref === "function") {
            ref(current);
          } else if (ref) {
            ref.current = current;
          }
        }}
        css={[styles.cue.wrapper]}
      >
        <div ref={setIntersectionRef} css={styles.cue.intersectionTarget} />
        <Clickable
          css={[styles.cue.base, disabled && styles.cue.disabled]}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </Clickable>
      </div>
    );
  }
);

export default ChatCue;
